Preview
Vue
<template>
    <ul class="my-4">
        <li v-for="(item, index) in block.Items" :key="index" class="flex items-center mt-2">
            <span class="bg-green-700 rounded-full p-1">
                <svg class="w-6 h-6 text-green-200" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
                </svg>
            </span>
            <span class="ml-2">{{ item.Text }}</span>
        </li>
    </ul>
</template>

<script>
    export default {
        name: "PositiveList",
        data() {
            return {
                block: {
                    Items: [
                        { Text: 'This is the first list item' },
                        { Text: 'This is a middle list item' },
                        { Text: 'This is the last list item' }
                    ]
                }
            }
        }
    };
</script>